/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFestivalTripTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFestivalTrip,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Festival Fun Awaits!",
    "Let’s Celebrate!",
    "Music, Food, and Fun!",
  ],
  title: "Festival Trip",
  description: "Plan an exciting trip to a festival.",
  longDescription:
    "Gather your friends for an unforgettable festival experience! Choose a date, decide on which festival to attend, and arrange transportation!",
  emoji: "🎉",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Festival Trip",
          emoji: "🎉",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go to the festival?",
          emoji: "📅",
          completeAction: {
            question: "Decide on which festival to attend?",
            description: "Which festival should we go to?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What festival should we attend?",
                emoji: "🎶",
                completeAction: {
                  question: "Decide on transportation?",
                  description: "How should we get to the festival?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What transportation should we use?",
                      emoji: "🚌",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Get Ready to Celebrate!",
    outroDescription:
      "Your festival trip plans are set! Enjoy the festivities!",
  },
};
